import React, { Component, useState } from 'react';
import { Grid, Button, Typography, Dialog, DialogTitle, TextField, Chip, CircularProgress, Box } from '@material-ui/core';
import TimeKeeper, { TimeOutput } from 'react-timekeeper';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import EditIcon from '@material-ui/icons/Edit';
import { SupplierDeliveriesProps } from '../connected/SupplierDeliveriesCnn';
import { SupplierDeliveryTime, DayOfWeek } from '../../api/models/SupplierDeliveryTime';
import * as moment from "moment";
import { toDeliveryTimes } from '../reducers/SupplierRdc';


type TimeSelectorProps = {
    isValid: boolean,
    label: string,
    value: string,
    onChange: (val: any) => void
    onDone: () => void
}

export const TimeSelector = (props: TimeSelectorProps) => {

    return (
        <Dialog aria-labelledby="simple-dialog-title" open={true}>
            <DialogTitle id="simple-dialog-title">Set {props.label.toLowerCase()} time</DialogTitle>
            <TimeKeeper
                time={props.value}
                onChange={props.onChange}
                doneButton={(newTime: TimeOutput) => (
                    <div style={{ textAlign: 'center', padding: '5px' }}>
                        <Button
                            style={{ textAlign: 'center', padding: '10px 0' }}
                            onClick={(e) => {
                                if (!props.isValid)
                                    e.stopPropagation()
                                else
                                    props.onDone()
                            }}
                        >
                            {props.isValid ? <span>Select</span> : <Typography variant="button" color="error">Selected time overlaps with other one or "from" time is later than "to" time!</Typography>}
                        </Button>
                    </div>
                )}
                hour24Mode
                coarseMinutes={15}
                forceCoarseMinutes
            />
        </Dialog>
    )
}


type TimeBlockProps = {
    dtb?: SupplierDeliveryTime,
    new: boolean,
    dayOfWeek: string,
    disabled: boolean,
    isBusy: boolean,
    currentDtbsInThisDay: SupplierDeliveryTime[],
    onSave: (dtb: SupplierDeliveryTime) => void,
    onDelete: (dtb: SupplierDeliveryTime) => void,
    onEditing: () => void,
}

function isOverlapping(dtbs: SupplierDeliveryTime[], val: moment.Duration) {
    return dtbs.find(dt => (val >= dt.startTime && val <= dt.endTime)) !== undefined
}

function getDefaultStartEndValues(dtbs: SupplierDeliveryTime[]) {
    let start: moment.Duration
    if (dtbs.length > 0) {
        let newVal = moment.duration(dtbs[dtbs.length - 1].endTime.toISOString())
        start = newVal.add(1, 'hour')
    }
    else
        start = moment.duration('6:00:00')

    let end: moment.Duration
    let newVal = moment.duration(start.toISOString())
    end = newVal.add(2, 'hour')

    return [start, end]
}

const TimeBlock = (props: TimeBlockProps) => {
    let [start, end] = getDefaultStartEndValues(props.currentDtbsInThisDay)
    let from = useTimeInput(props.dtb ? props.dtb.startTime : start)
    let to = useTimeInput(props.dtb ? props.dtb.endTime : end)

    let [editing, setEditing] = useState(false)
    let [removing, setRemoving] = useState(false)
    return (
        <div>
            {!props.new &&
                <div>
                    {(props.isBusy && removing) ?
                        <CircularProgress size={50} />
                        :
                        <Chip
                            disabled={editing ? false : props.disabled}
                            style={{ minHeight: '40px', marginTop: '6px' }}
                            icon={editing ? <EditIcon /> : <LocalShippingIcon />}
                            size="medium"
                            label={(<div>{toLabelString(props.dtb!.startTime)} <br /> {toLabelString(props.dtb!.endTime)}</div>)}
                            onClick={() => {
                                if (!editing)
                                    props.onEditing(); setEditing(true)
                            }}
                            onDelete={editing ? undefined : () => { setRemoving(true); props.onDelete(props.dtb!); }}
                            color="primary"
                        />
                    }
                </div>
            }

            {(props.new || editing) &&
                <div>
                    {props.isBusy ?
                        <CircularProgress size={50} />
                        :

                        <div>
                            <TextField
                                inputProps={{ style: { textAlign: 'center' } }}
                                label="From:"
                                margin="normal"
                                value={from.label}
                                onClick={() => { from.setShow(!from.show) }}
                            />
                            {from.show &&
                                <TimeSelector
                                    value={from.label}
                                    onChange={from.onChange}
                                    onDone={() => {
                                        from.setShow(false);
                                        if (to.value <= from.value) {
                                            let toVal = moment.duration(from.value.toISOString())
                                            to.setValue(toVal.add(1, 'hour'))
                                        }
                                    }}
                                    isValid={(() => {
                                        let toCompareWith = editing ? props.currentDtbsInThisDay.filter(dt => dt.id! !== props.dtb!.id!) : props.currentDtbsInThisDay
                                        return !isOverlapping(toCompareWith, from.value)
                                        //return toCompareWith.find(dt => dt.startTime <= from.value && from.value <= dt.endTime) === undefined
                                    })()
                                    }
                                    label="From" />
                            }

                            <TextField
                                inputProps={{ style: { textAlign: 'center' } }}
                                label="To:"
                                margin="normal"
                                value={to.label}
                                onClick={() => { to.setShow(!to.show) }}
                            />
                            {to.show &&
                                <TimeSelector
                                    value={to.label}
                                    onChange={to.onChange}
                                    onDone={() => {
                                        to.setShow(false)
                                    }}
                                    isValid={(() => {
                                        let toCompareWith = editing ? props.currentDtbsInThisDay.filter(dt => dt.id! !== props.dtb!.id!) : props.currentDtbsInThisDay
                                        return (to.value > from.value) && !isOverlapping(toCompareWith, to.value)
                                    })()}
                                    label="To" />
                            }
                        </div>
                    }

                    <Button onClick={() => { setEditing(false); props.onSave({ id: (editing ? props.dtb!.id : undefined), startTime: from.value, endTime: to.value, weekday: (parseInt(props.dayOfWeek) as DayOfWeek), timezone: Intl.DateTimeFormat().resolvedOptions().timeZone }) }} >Save</Button>
                    <Button onClick={() => { setEditing(false); props.onEditing() }} >Cancel</Button>
                </div>
            }
        </div>
    )
}

function toLabelString(duration: moment.Duration) {
    return moment.utc(duration.asMilliseconds()).format("HH:mm")
}

function useTimeInput(initialValue: moment.Duration) {
    let [value, setValue] = useState(initialValue)
    let [show, setShow] = useState(false)

    function onChange(data: any) { setValue(moment.duration(data.hour + ":" + data.minute + ":00")) }
    return { label: toLabelString(value), value, onChange, show, setShow, setValue }
}


type DaySelectorProps = {
    day: string,
    deliveries: SupplierDeliveryTime[],
    inEditMode: boolean,
    isBusy: boolean,
    onSave: (dtb: SupplierDeliveryTime) => void,
    onDelete: (dtb: SupplierDeliveryTime) => void,
    onEditing: () => void
}

const DaySelector = (props: DaySelectorProps) => {
    let [addNewOpen, setAddNewOpen] = useState(false)

    function onDeliveryTimeSave(dtb: SupplierDeliveryTime) {
        props.onSave(dtb)
        props.onEditing()
        setAddNewOpen(false)
    }

    function onDeliveryAdding() {
        setAddNewOpen(true)
        props.onEditing()
    }

    function onDeliveryEditing() {
        setAddNewOpen(false)
        props.onEditing()
    }

    return (
        <Grid item xs={12} sm style={{ textAlign: 'center' }}>
            <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: props.deliveries.length > 0 ? "green" : "inherit" }}>{days[props.day + 'd']}</Typography>
            <hr />

            {props.deliveries.map((d, i) => {
                return <TimeBlock key={i} dtb={d} currentDtbsInThisDay={props.deliveries} isBusy={props.isBusy} new={false} disabled={props.inEditMode || props.isBusy} dayOfWeek={props.day} onSave={onDeliveryTimeSave} onDelete={props.onDelete} onEditing={onDeliveryEditing} />
            })}
            {addNewOpen ?
                <div>
                    <TimeBlock new={true} disabled={props.inEditMode} currentDtbsInThisDay={props.deliveries} isBusy={props.isBusy} dayOfWeek={props.day} onSave={onDeliveryTimeSave} onDelete={props.onDelete} onEditing={onDeliveryEditing} />
                </div>
                :
                <>
                    {props.isBusy ?
                        <Box p={1}><CircularProgress size={25} /></Box>
                        :
                        <Button style={{ marginTop: '6px' }} disabled={props.inEditMode} onClick={onDeliveryAdding}>+Add</Button>
                    }
                </>
            }

        </Grid>
    );
}

//suffixed with d to prevent sorting of object keys.
const days: { [id: string]: string } = { '1d': 'MON', '2d': 'TUE', '3d': 'WED', '4d': 'THU', '5d': 'FRI', '6d': 'SAT', '0d': 'SUN' }

type State = {
    inEditMode: boolean
}
class SupplierDeliveryTimeSetter extends Component<SupplierDeliveriesProps, State> {
    constructor(props: SupplierDeliveriesProps) {
        super(props)

        this.state = {
            inEditMode: false
        }
    }

    render() {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                    <Typography variant="h2">Setup deliveries</Typography>
                    <Typography variant="h5">You can set below exact days & hours when you are planning a deliveries.</Typography>
                </Grid>
                <br />
                <br />
                <br />
                {this.props.deliveryTimes &&
                    <Grid container spacing={1}>
                        {Object.keys(days).map((d, i) => {
                            return (<DaySelector
                                key={i}
                                day={d.replace('d', '')}
                                inEditMode={this.state.inEditMode}
                                isBusy={this.props.deliveryTimesBusy}
                                deliveries={toDeliveryTimes(this.props.deliveryTimes!).filter(de => de.weekday === parseInt(d)).sort((a, b) => {
                                    if (a.startTime < b.startTime)
                                        return -1
                                    else
                                        return 1
                                })}
                                onSave={(dtb: SupplierDeliveryTime) => {
                                    dtb.supplierId = this.props.supplierInfo!.id
                                    this.props.updateSupplierDeliveryTimes([dtb])
                                }}
                                onDelete={(dtb: SupplierDeliveryTime) => {
                                    this.props.removeSupplierDeliveryTime(dtb)
                                }}
                                onEditing={() => {
                                    this.setState({ inEditMode: !this.state.inEditMode })
                                }}
                            />)
                        })}
                    </Grid>
                }
            </Grid>
        );
    }
}

export default SupplierDeliveryTimeSetter;